module.exports = __webpack_public_path__ + "img/card-table7.9cc727d1.svg";